import {Component, OnDestroy, OnInit} from '@angular/core';
import {combineLatest, Subject} from "rxjs";
import {CalculationService, DealService, VehicleService} from "../../../services";
import {ActivatedRoute, Router} from "@angular/router";
import {DealState} from "../../../store/state";
import {take, takeUntil} from "rxjs/operators";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {Vehicle} from "../../../models";
import swal, {SweetAlertOptions} from "sweetalert2";

@Component({
  selector: 'app-tax-lookup-modal',
  templateUrl: './tax-lookup-modal.component.html',
  styleUrls: ['./tax-lookup-modal.component.scss']
})
export class TaxLookupModalComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject();

  public responseReceived = false;
  public responseData: any = {};

  public sellingPrice = 0;
  public deal!: DealState;
  public vehicle!: Vehicle;

  buyerAddressForm: UntypedFormGroup = this.formBuilder.group({
    street: new UntypedFormControl(''),
    city: new UntypedFormControl(''),
    county: new UntypedFormControl(''),
    state: new UntypedFormControl(''),
    zipCode: new UntypedFormControl(''),
    zipCodeExt: new UntypedFormControl(''),
  });

  buyerForm: UntypedFormGroup = this.formBuilder.group({
    isIndividual: new UntypedFormControl(true),
    ownerType: new UntypedFormControl('Individual'),
    dlNotMatchName: new UntypedFormControl(false),
    ownersAddressMatchOwnersId: new UntypedFormControl(true),
    applyingForPrimaryAddressException: new UntypedFormControl(false),
    fein: new UntypedFormControl(''),
    businessName: new UntypedFormControl(''),
  });

  constructor(
    private dealService: DealService,
    private vehicleService: VehicleService,
    private calculationService: CalculationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
  ) {
  }

  ngOnInit() {

    combineLatest([
      this.activatedRoute.queryParams,
      this.dealService.selectDeal(),
      this.vehicleService.selectVehicle(),
      this.calculationService.totalVehicleFinancePrice$({
        withoutDaysToFirstPay: true,
        actualTrade: true
      })
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([params, deal, vehicle, totalAmountFinanced]) => {

        this.sellingPrice = totalAmountFinanced;
        this.deal = deal;
        this.vehicle = vehicle;

        //console.log("Tax Lookup Params:", totalAmountFinanced, deal, vehicle);

        this.buyerAddressForm.patchValue({
          street: deal?.customer?.street || '',
          city: deal?.customer?.city || '',
          county: deal?.customer?.county || '',
          state: deal?.customer?.state || '',
          zipCode: deal?.customer?.zip || '',
        });

        if (params.changeDealOnSelectVehicle === "false") {
          //this.changeDealOnSelectVehicle = false;
        }
        if (params.dispatchStockNumberOnly === "true") {
          //this.dispatchStockNumberOnly = true;
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  totalFees = 0;
  totalTaxes = 0;

  lookupTaxes() {
    //console.log("Looking Up Taxes.");
    //console.log("Vitu Fees Request Body:", this.generateRequestBody());
    //console.log("Sending to Vitu:", this.dealService.taxLookupDeal, this.dealService.taxLookupVehicle)

    this.dealService.getVituTaxes(this.deal, this.vehicle, this.sellingPrice)
      //of(this.mockData)
      .pipe(take(1))
      .subscribe(
        response => {
          //console.log("Response from Vitu:", response);
          this.responseReceived = true;
          this.responseData = response;
          delete (this.responseData.payload);
          delete (this.responseData.extraData);
          if (this.responseData?.fees?.length > 0) {

            this.responseData.fees = this.responseData.fees.filter((fee: any) => {
              return fee.name !== "Electric Fee" &&
                fee.name !== "Out of State Vehicle Check Fee" &&
                fee.name !== "Transportation Benefit District Fee";
            });

            this.responseData.fees.forEach(fee => {
              if (fee.feeType === "StateTax") {
                this.totalTaxes += fee.value;
              } else {
                this.totalFees += fee.value;
              }
            });
          }
        },
        error => {
          console.error("Error from Vitu:", error);
          swal.fire({
            title: "Vitu Tax Lookup Failed",
            html: `If this problem continues to occur,<br> perform a manual tax lookup instead.`,
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "OK",
          } as SweetAlertOptions).then();
        }
      );
  }

  back = () => {
    //console.log("Back to Previous Screen");
    this.responseReceived = false;
    this.responseData = {};
  };

  applyUpdates = () => {
    //console.log("Applying Updates");
    this.router.navigate([{outlets: {modal: null}}]).then();
    this.dealService.setStateTaxesFees(this.totalTaxes, this.totalFees);
  };
}
